export function prepareFilters(filters) {
  return JSON.parse(JSON.stringify(filters));
}

export function prepareSort({ sortBy, sortDesc }) {
  const sort = sortBy.map((el) => ({ field: el }));
  sortDesc.forEach((el, index) => (sort[index].dir = el ? 'desc' : 'asc'));
  return sort;
}
